import { ErrorPage, ErrorPageType } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QBankStructureAuditLogLayout() {
  const { pageAccessibility } = useQBankStructure();

  if (!pageAccessibility.auditLog) {
    return <ErrorPage errorType={ErrorPageType.NO_PERMISSION} />;
  }

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW}>
      <Outlet />
    </PermissionGuard>
  );
}
